import { PropsWithChildren } from "react";

export const ModalBody = ({ children }: PropsWithChildren<{}>) => (
  <div className="font-primary mt-2 px-6 py-4 text-base text-black-lighter">
    {children}
  </div>
);
